/* IMPORT */
import { SYMBOL_OBSERVABLE, SYMBOL_OBSERVABLE_FROZEN, SYMBOL_OBSERVABLE_READABLE, SYMBOL_OBSERVABLE_WRITABLE } from '../symbols.js';
import { isFunction } from '../utils.js';
import { deepResolve } from '../methods/deep_resolve.js';
/* MAIN - FUNCTIONS */
function frozenFunction() {
    if (arguments.length) {
        throw new Error('A readonly Observable can not be updated');
    }
    else {
        return this;
    }
}
function readableFunction() {
    if (arguments.length) {
        throw new Error('A readonly Observable can not be updated');
    }
    else {
        return this.get();
    }
}
function writableFunction(fn) {
    if (arguments.length) {
        if (isFunction(fn)) {
            return this.update(fn);
        }
        else {
            return this.set(fn); //TSC
        }
    }
    else {
        return this.get();
    }
}
/* MAIN - GENERATORS */
const frozen = (value) => {
    // value.stack = stack
    const fn = frozenFunction.bind(value); //TSC
    fn[SYMBOL_OBSERVABLE] = true;
    fn[SYMBOL_OBSERVABLE_FROZEN] = true;
    return fn;
};
const readable = (value, stack) => {
    //TODO: Make a frozen one instead if disposed
    value.stack = stack;
    const fn = readableFunction.bind(value); //TSC
    fn.valueOf = () => deepResolve(fn);
    fn.toString = () => fn.valueOf().toString();
    fn[SYMBOL_OBSERVABLE] = true;
    fn[SYMBOL_OBSERVABLE_READABLE] = value;
    return fn;
};
/**
 * Creates a writable observable function with enhanced type information.
 * The returned function can be used as both a getter and setter for the observable value.
 *
 * @param value - The observable instance to wrap
 * @param stack - Optional debugging stack trace
 * @returns A function that acts as both getter and setter with proper type annotations
 */
const writable = (value, stack) => {
    value.stack = stack;
    const fn = writableFunction.bind(value); //TSC
    fn.valueOf = () => deepResolve(fn);
    fn.toString = () => fn.valueOf().toString();
    fn[SYMBOL_OBSERVABLE] = true;
    fn[SYMBOL_OBSERVABLE_WRITABLE] = value;
    return fn;
};
/* EXPORT */
export { frozen, readable, writable };
